import { addSlidesTabIndex } from './swiper/add-slides-tab-index';

const swiperHelpers = {
    addSlidesTabIndex,
};

export default swiperHelpers;
